import Vue from 'vue'
import Meta from 'vue-meta'
import Element from 'element-ui'
import { ElementTiptapPlugin } from 'element-tiptap'
import App from '@/App'

import config from '@/config'
import store from '@/services/store'
import router from '@/services/routes'

import storeData from '@/services/mixins/storeData'
import displayMessage from '@/services/mixins/displayMessage'
import clone from '@/services/mixins/clone'
import objectLength from '@/services/mixins/objectLength'
import redirectTo from '@/services/mixins/redirectTo'
import removeLoader from '@/services/mixins/removeLoader'
import teamRoles from '@/services/mixins/teamRoles'
import isPlanExceed from '@/services/mixins/isPlanExceed'
import openTrialExpiredDialog from '@/services/mixins/openTrialExpiredDialog'
import openPlanLimitDialog from '@/services/mixins/openPlanLimitDialog'

import locale from 'element-ui/lib/locale/lang/en'
import 'element-tiptap/lib/index.css'

Vue.use(Meta)
Vue.use(Element, {locale})
Vue.mixin(storeData)
Vue.mixin(displayMessage)
Vue.mixin(clone)
Vue.mixin(objectLength)
Vue.mixin(redirectTo)
Vue.mixin(removeLoader)
Vue.mixin(teamRoles)
Vue.mixin(isPlanExceed)
Vue.mixin(openTrialExpiredDialog)
Vue.mixin(openPlanLimitDialog)

Vue.use(ElementTiptapPlugin, {
	lang: 'en',
	spellcheck: false
})

Vue.config.productionTip = false
Vue.prototype.$config = config

new Vue({
	store,
    router,
    render: h => h(App)
}).$mount('#app')
